import { humanizeNumber, fixFloatNumber } from "../../tools/market/functions"

export const config = [
    {
        key: "l18",
        value: 'نماد',
        sortable: false,
        renderer: (row) => row.l18 !== undefined ? <a target="_blank" rel="noreferrer" href={`https://www.tsetmc.com/instInfo/${row._id}`}>{row.l18}</a> : 'x'

    },
    {
        key: 'date',
        value: 'تاریخ',
        sortable: false,
        renderer: (row) => row.date !== undefined ? row.date : 'x'
    },
    {
        key: 'today_pl',
        value: 'قیمت جدید',
        sortable: false,
        renderClass: (row) => row.today_pl !== undefined ? 'bg-success-light' : '',
        renderer: (row) => row.today_pl !== undefined ? humanizeNumber(row.today_pl) : 'x'
    },
    {
        key: 'last_pl',
        value: 'قیمت قدیم',
        sortable: false,
        renderClass: (row) => row.last_pl !== undefined ? 'bg-danger-light' : '',
        renderer: (row) => row.last_pl !== undefined ? humanizeNumber(row.last_pl) : 'x'
    },
    {
        key: 'value',
        value: 'مقدار تعدیل',
        sortable: false,
        renderClass: (row) => row.pl !== undefined ? 'bg-primary-light' : '',
        renderer: (row) => row.value !== undefined ? humanizeNumber(row.value) : 'x',
        direction: 'ltr',
    },
    {
        key: 'percent',
        value: 'درصد تعدیل',
        sortable: false,
        renderer: (row) => row.percent !== undefined ? humanizeNumber(fixFloatNumber(row.percent * 100)) : 'x',
        direction: 'ltr',

    },
]